var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switch",class:{ 'switch--active-only': _vm.activeOnly },on:{"click":function($event){$event.stopPropagation();}}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event.target.checked)}}}),_c('span',{staticClass:"slider round"})])
}
var staticRenderFns = []

export { render, staticRenderFns }